import useAxiosAuthentication from "@/compositions/useAxiosAuthentication";
import axios, { type AxiosRequestConfig } from "axios";
import { DEFAULT_HEADERS } from "@/compositions/useAxios/data.ts";

const axiosInstance = axios.create();
useAxiosAuthentication(axiosInstance);

const getAll = async (config: AxiosRequestConfig) => {
  const url = `${import.meta.env.VITE_API_CP_TRACKING_BASE_URL}/shipment-tracking/air/lookup`;
  let response = null;

  try {
    response = await axiosInstance.get<string>(url, {
      ...config,
      headers: {
        ...config?.headers,
        ...DEFAULT_HEADERS
      }
    });
    return response;
  } catch (error) {
    console.error("Error fetching data:", error);
    return {
      status: error?.response?.status,
      message: error?.message,
      details: error?.response?.data
    };
  }
};

export default { getAll };
